<template>
  <div v-if="recipesLoaded">
    <RecipeView :recipe="recipe"></RecipeView>
  </div>
  <div v-else>
    <p>Loading...</p>
  </div>
</template>

<script>
import RecipeView from "./RecipeView.vue";
import { mapGetters } from "vuex";
//import RecipeEdit from "./RecipeEdit.vue";

export default {
    data() {
        return {
            id: ""
        };
    },

    created() {
        this.id = this.$route.params.id;
    },

    components: {
        RecipeView: RecipeView /*,
        recipeEdit: RecipeEdit*/
    },

    computed: {
        ...mapGetters(["recipesLoaded"]),
        recipe() {
            const id = this.id;
            return this.$store.getters.recipeById(id);
        }
    },

    methods: {}
};
</script>
